import { render, staticRenderFns } from "./simple-plus.vue?vue&type=template&id=115264c6&scoped=true"
import script from "./simple-plus.vue?vue&type=script&lang=js"
export * from "./simple-plus.vue?vue&type=script&lang=js"
import style0 from "./simple-plus.vue?vue&type=style&index=0&id=115264c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115264c6",
  null
  
)

export default component.exports